import React from 'react';
import PropTypes from 'prop-types';
import './Tooltip.css';

/**
 * Universelle Tooltip-Komponente zur Wiederverwendung (ersetzt CSS-Pseudo-Lösungen).
 * Nutzt vorhandene .btn-tooltip Styles aus Common.css für einheitliche Darstellung.
 * Umschließt ein beliebiges Kind (fokussierbar empfohlen) und zeigt bei Hover/Fokus den Tooltip.
 */
const Tooltip = ({ children, text, ariaLabel, position = 'top', align = 'center' }) => {
  const [visible, setVisible] = React.useState(false);
  const reactId = React.useId();
  const tooltipId = `tooltip-${reactId}`;

  // Event-Handler: wir binden an den Wrapper, sodass auch Icons ohne eigene Events funktionieren.
  const show = () => setVisible(true);
  const hide = () => setVisible(false);

  // Falls das Kind ein einziges Element ist, fügen wir aria-describedby hinzu.
  const enhancedChild = React.isValidElement(children)
    ? React.cloneElement(children, {
        'aria-describedby': tooltipId,
        'aria-label': ariaLabel || children.props['aria-label'],
      })
    : children;

  const positionClass = position === 'bottom' ? 'tooltip-bottom' : '';
  const alignClass = align !== 'center' ? `tooltip-${align}` : '';
  const wrapperClasses = `btn-tooltip-wrapper ${positionClass} ${alignClass}`.trim();

  return (
    <span
      className={wrapperClasses}
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
    >
      {enhancedChild}
      <span
        id={tooltipId}
        role="tooltip"
        className="btn-tooltip"
        data-visible={visible ? 'true' : 'false'}
      >
        {text}
      </span>
    </span>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  ariaLabel: PropTypes.string,
  position: PropTypes.oneOf(['top', 'bottom']),
  align: PropTypes.oneOf(['center', 'left', 'right']),
};

export default Tooltip;

